function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 2)",
  fill: "none"
}, React.createElement("path", {
  d: "M12.485 12.29a5.257 5.257 0 013.804-1.633c1.98 0 3.709 1.104 4.629 2.744a6.396 6.396 0 012.616-.556c3.572 0 6.468 2.92 6.468 6.524 0 3.603-2.896 6.525-6.468 6.525-.428 0-.855-.043-1.274-.127a4.727 4.727 0 01-6.195 1.945 5.395 5.395 0 01-10.028-.244 4.917 4.917 0 01-1.03.108C2.243 27.576 0 25.31 0 22.516a5.068 5.068 0 012.504-4.383A5.823 5.823 0 017.852 10a5.82 5.82 0 014.633 2.29",
  fill: "#00A1E0"
}), React.createElement("circle", {
  stroke: "#FEFBF3",
  strokeWidth: 2,
  fill: "#FCA000",
  cx: 27,
  cy: 8,
  r: 9
}), React.createElement("path", {
  d: "M28.086 11.578a1.057 1.057 0 10-2.114 0 1.057 1.057 0 002.114 0zM26.331 2.77a.356.356 0 00-.36.37l.323 5.99c.012.19.17.336.36.334h.757a.357.357 0 00.36-.334l.322-5.99a.356.356 0 00-.36-.37h-1.402z",
  fill: "#FEFBF1"
}));

var SvgSalesforceWarningIcon = function SvgSalesforceWarningIcon(props) {
  return React.createElement("svg", _extends({
    width: 37,
    height: 33
  }, props), _ref);
};

export default SvgSalesforceWarningIcon;